import styled, { css, keyframes } from 'styled-components';
import { FlexibleDiv } from '../../../styled/common';
import { HeaderCloseButton } from '../../ui/PageHeader/styled';
import {
  CardFooter,
  CardPreview,
  ItemCardStyled
} from '../../ui/ItemCard/styled';
import {
  ResidenceCardPreview,
  ResidenceCardStyled
} from '../../Cards/ResidencesCard/styled';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const PanelWrapper = styled.div<{ $isFullScreen: boolean }>`
  position: absolute;
  top: 20px;
  left: 20px;
  width: 280px;
  height: calc(100% - 40px);
  background-color: ${({ theme }) => theme.colors.background.primary};
  border-radius: 14px;
  z-index: 100;
  padding: 5px 0 0;
  animation: ${fadeIn} 0.2s ease-out forwards;

  ${({ $isFullScreen }) =>
    $isFullScreen &&
    css`
      position: fixed;
      top: 20px;
      left: 20px;
      bottom: 20px;
      z-index: 9999999;
    `}
`;

export const PanelHeader = styled(FlexibleDiv)`
  position: relative;
  height: 40px;
  justify-content: flex-end;

  ${HeaderCloseButton} {
    width: 40px;
    right: 0;
    left: auto;
    padding: 0;

    path {
      fill: ${({ theme }) => theme.colors.text.secondary};
    }
  }
`;

const itemCardStyles = css`
  ${ItemCardStyled} {
    max-width: 100%;
    margin: 0;

    &:not(:last-of-type) {
      margin-bottom: 20px;
    }

    ${CardPreview} {
      max-height: 140px;
      height: 140px;
      padding-top: 30%;
    }
  }

  ${CardFooter} {
    button {
      height: 40px;
    }
  }
`;

const residenceCardStyles = css`
  ${ResidenceCardStyled} {
    margin: 0;

    ${ResidenceCardPreview} {
      max-height: 131px;
      height: 131px;
      padding-top: 30%;
    }
  }
`;

export const PanelContent = styled.div`
  height: calc(100% - 60px);
  overflow-y: auto;
  padding: 15px 20px 0;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    width: 4px;
    background-color: ${({ theme }) => theme.colors.text.tertiary};
    border-radius: 10px;
  }

  scrollbar-width: thin;
  scrollbar-color: ${({ theme }) => theme.colors.text.tertiary} transparent;

  ${itemCardStyles};
  ${residenceCardStyles};
`;
